export const ToggleLanguage = ({
  language,
  onChange,
}: {
  language: 'en' | 'es'
  onChange: (_next: 'en' | 'es') => void
}) => {
  const checked = language === 'es'
  return (
    <div className="input-wrapper" style={{ width: '100%' }}>
      <div className="input-label language">English</div>
      <div className="input-container">
        <label className="switch">
          <input
            type="checkbox"
            checked={checked}
            onChange={() => onChange(checked ? 'en' : 'es')}
          />
          <span className="slider sliderLanguage"></span>
        </label>
        <span className="right-label">Spanish</span>
      </div>
    </div>
  )
}
